import React from 'react';
import PropTypes from 'prop-types';
import './error-display.css';

/**
 * Reusable error display component
 * @param {Object} props - Component props
 * @param {string} props.message - Error message to display
 * @param {string} props.type - Type of error: 'danger' (default), 'warning', or 'info'
 * @param {string} props.className - Additional CSS classes
 * @param {Function} props.onDismiss - Optional callback for dismissing the error
 * @returns {JSX.Element|null} - Error display component or null if no message
 */
const ErrorDisplay = ({ 
  message, 
  type = 'danger', 
  className = '',
  onDismiss = null
}) => {
  if (!message) return null;
  
  // Determine error type class
  const typeClass = `error-${type}`;
  
  // Combine classes
  const containerClasses = `error-container ${typeClass} ${className}`.trim();
  
  return (
    <div className={containerClasses} role="alert">
      {message}
      {onDismiss && (
        <button 
          type="button" 
          className="btn-close float-end" 
          aria-label="Close"
          onClick={onDismiss}
        />
      )}
    </div>
  );
};

ErrorDisplay.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(['danger', 'warning', 'info']),
  className: PropTypes.string,
  onDismiss: PropTypes.func
};

export default ErrorDisplay;